import { render, staticRenderFns } from "./ChildInputGroup.vue?vue&type=template&id=96e0b072"
import script from "./ChildInputGroup.vue?vue&type=script&lang=js"
export * from "./ChildInputGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports